import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/pages/auth/AuthShell";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", org_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      toast.success("Organisation created");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your organisation"
      subtitle="Start capturing questions, participation and feedback."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-accent hover:underline">Sign in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label htmlFor="name">Your name</Label>
            <Input id="name" value={form.name} onChange={set("name")} required className="mt-1.5" placeholder="Amara Okafor" data-testid="register-name" />
          </div>
          <div>
            <Label htmlFor="org">Organisation</Label>
            <Input id="org" value={form.org_name} onChange={set("org_name")} required className="mt-1.5" placeholder="Sahara Events" data-testid="register-org" />
          </div>
        </div>
        <div>
          <Label htmlFor="email">Work email</Label>
          <Input id="email" type="email" value={form.email} onChange={set("email")} required className="mt-1.5" placeholder="you@company.com" data-testid="register-email" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" value={form.password} onChange={set("password")} required minLength={8} className="mt-1.5" placeholder="Min. 8 characters" data-testid="register-password" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-11 rounded-md bg-accent text-accent-foreground hover:opacity-90 transition-opacity" data-testid="register-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
    </AuthShell>
  );
}
